<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="12" md="6" lg="6">
        <IncomeTaxList />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import IncomeTaxList from './componnents/IncomeTaxList'

export default {
  name: 'IncomeTax',
  components: { IncomeTaxList },
  data: () => {
    return {}
  },
}
</script>
